import data from "../../.sourceflow/expectations.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getExpectations = (locale = "en") => {
  return new BaseCollection(data, locale).orderBy((i) => parseInt(i["_order"])).getItems();
};
